<app-material class="material">
    <div class="header" header>
        <h2>{{ 'admin.tickets.table.title' | translate }}</h2>
        <div class="actions">
            <app-report-download-form [tableConfig]="tableConfig"
                                      [appendTo]="'body'"
                                      outputDateFormat="timestamp"
                                      (filterChange)="onFilterChange($event)"
                                      (reportDownload)="onDownloadTicketsReport()">
            </app-report-download-form>
            <app-button *ngIf="canManageTickets"
                        type="primary"
                        class="add-ticket-btn"
                        (click)="openTicketModal()">{{
                    'admin.tickets.buttons.addTicket' |
                        translate
                }}
            </app-button>
        </div>
    </div>
    <ng-container body>
        <app-tickets-table [tickets]="tickets"
                           [tableConfig]="tableConfig"
                           [isLoading]="isLoadingTickets"
                           [hasTitle]="false"
                           [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                           (sortChange)="onSortChange($event)"
                           (filterChange)="onFilter($event)"
                           (rowClick)="canManageTickets ? onTableRowClick($event) : null"
                           (pageChange)="pageChange($event)">
        </app-tickets-table>
    </ng-container>
</app-material>

<span *ngIf="canManageTickets">
    <app-ticket-create-modal (create)="createTicket($event)"
                             (ticketCheck)="checkForSimilarTickets($event)"
                             [config]="tableConfig"
                             [similarTickets]="similarTickets"
                             [isLoading]="isLoading"></app-ticket-create-modal>
</span>
<app-confirmation-modal #errorModal
                        title="{{'lineSetter.toolRequest.pages.popupError' | translate }}"
                        [message]="confirmationPopupMessage"
                        [confirmOnlyMode]="true"
                        [showConfirmButton]="false ">
</app-confirmation-modal>
